var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app-bar',{attrs:{"app":"","flat":"","color":"white"}},[_c('v-icon',{staticClass:"mr-3",on:{"click":function($event){$event.preventDefault();return _vm.$router.go(-1)}}},[_vm._v("mdi-arrow-left")]),_c('v-toolbar-title',[_c('span',{staticClass:"font-weight-light primary--text"},[_vm._v(_vm._s(_vm.title))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }